import { MACHINE_TYPES } from '../Game/definitions.js'

export default class MachineView
{
    constructor(_options)
    {
        this.machine = _options.machine
        this.factory = _options.factory
        this.container = this.factory.createMachine(this.machine.type)
        this.container.position.set(this.machine.x, this.machine.y, 0)
        this.container.scale.setScalar(0.01)
        this.lastStackKey = ''
        this.sync()
    }

    clearStack(_anchor)
    {
        for(const child of [..._anchor.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            _anchor.remove(child)
        }
    }

    fillStack(_anchor, _entries)
    {
        this.clearStack(_anchor)
        let index = 0
        for(const [resource, count] of _entries)
        {
            for(let itemIndex = 0; itemIndex < count; itemIndex++)
            {
                const item = this.factory.createItem(resource, 0.9)
                item.position.set((index % 3 - 1) * 0.3, (Math.floor(index / 3) % 3 - 1) * 0.28, Math.floor(index / 9) * 0.18)
                item.rotation.z = (index % 3 - 1) * 0.12
                _anchor.add(item)
                index++
            }
        }
    }

    sync()
    {
        const definition = MACHINE_TYPES[this.machine.type]
        const key = JSON.stringify([this.machine.inputs, this.machine.output])
        if(key === this.lastStackKey)
            return
        this.lastStackKey = key
        const inputs = Object.entries(this.machine.inputs).filter(([resource]) => resource !== 'coal' && resource !== 'timber')
        const fuel = Object.entries(this.machine.inputs).filter(([resource]) => resource === 'coal' || resource === 'timber')
        for(const [resource, anchor] of Object.entries(this.container.userData.inputs))
            this.fillStack(anchor, inputs.filter(([input]) => input === resource))
        this.fillStack(this.container.userData.fuel, fuel)
        this.fillStack(this.container.userData.output, definition.output ? [[definition.output, this.machine.output]] : [])
    }

    update(_elapsed)
    {
        const parts = this.container.userData
        const definition = MACHINE_TYPES[this.machine.type]
        if(parts.fuelStatus)
        {
            const fuelCount = (this.machine.inputs.coal ?? 0) + (this.machine.inputs.timber ?? 0)
            const needsFuel = definition.fuel && fuelCount === 0 && this.machine.fuelRemaining < 2
            parts.fuelStatus.visible = needsFuel
            parts.fuelStatus.position.z = 2.95 + Math.sin(_elapsed * 0.006) * 0.16
            parts.fuelStatus.rotation.z = Math.sin(_elapsed * 0.004) * 0.08
            const pulse = 0.92 + Math.sin(_elapsed * 0.01) * 0.1
            parts.fuelStatus.scale.setScalar(pulse)
            parts.exclamationMaterial.opacity = 0.45 + (Math.sin(_elapsed * 0.012) * 0.5 + 0.5) * 0.55
        }

        parts.fire.visible = this.machine.active
        parts.smoke.visible = this.machine.active
        if(this.machine.active)
        {
            parts.fire.scale.setScalar(0.9 + Math.sin(_elapsed * 0.018) * 0.14)
            if(this.machine.type.includes('Fabricator'))
                parts.movingPart.position.z = - Math.abs(Math.sin(_elapsed * 0.009)) * 0.25
            else if(this.machine.type.includes('Drill'))
            {
                parts.drillBit.rotation.z = - _elapsed * 0.018
                parts.piston.position.z = 1.25 + Math.sin(_elapsed * 0.009) * 0.18
                parts.flywheel.rotation.x = _elapsed * 0.012
                parts.beam.rotation.y = Math.sin(_elapsed * 0.009) * 0.16
            }

            for(const puff of parts.smoke.children)
            {
                const phase = (_elapsed * 0.0007 + puff.userData.offset) % 2
                puff.position.z = (puff.userData.baseZ ?? 2.55) + phase * 0.65
                puff.position.x = (puff.userData.baseX ?? 0.42) + Math.sin(phase * 3) * 0.12
                puff.material.opacity = (1 - phase / 2) * 0.45
            }
        }
    }
}
